import { render, staticRenderFns } from "./DestaqueDoChatDeSuporte.vue?vue&type=template&id=90b0f832&scoped=true&"
import script from "./DestaqueDoChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./DestaqueDoChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./DestaqueDoChatDeSuporte.vue?vue&type=style&index=0&id=90b0f832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b0f832",
  null
  
)

export default component.exports